var requireComponent = require.context('./', false, /\w+\.vue$/);
var comps = {};
requireComponent.keys().map(function (fileName) {
  var comp = requireComponent(fileName).default;
  comps[comp.name] = comp;
});
export default comps;